import { Link } from "@remix-run/react";
import { Quote } from "lucide-react";

const pressMentions = [
  {
    name: "El Español",
    quote: "La startup que revoluciona el espacio flexible",
    url: "https://www.elespanol.com/invertia/disruptores/ecosistema-startup/startups/20260107/startup-revoluciona-espacio-flexible-alquilan-horas-dias-turnos-profesionales-digital/1003744076303_0.html",
  },
  {
    name: "La Vanguardia",
    quote: "Una plataforma valenciana ofrece espacios de trabajo compartido en plena crisis inmobiliaria",
    url: "https://www.lavanguardia.com/local/valencia/20260124/11444528/plataforma-valenciana-ofrece-espacios-trabajo-compartido-plena-crisis-inmobiliaria.html",
  },
];

export function PressBanner() {
  return (
    <section className="py-16 mt-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-2">
            Hablan de nosotros
          </p>
          <div className="w-12 h-0.5 bg-primary/30 mx-auto" />
        </div>

        {/* Press Mentions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {pressMentions.map((press) => (
            <a
              key={press.name}
              href={press.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col gap-3 rounded-xl border border-border/60 bg-muted/30 p-6 hover:border-primary/30 hover:bg-muted/50 transition-all duration-300"
              title={`Leer artículo en ${press.name}`}
            >
              <Quote className="w-5 h-5 text-primary/40 group-hover:text-primary/70 transition-colors" />
              <p className="text-base font-medium leading-snug text-foreground/90 italic">
                {`\u201C${press.quote}\u201D`}
              </p>
              <span className="text-sm font-semibold uppercase tracking-widest text-muted-foreground group-hover:text-primary transition-colors">
                {press.name}
              </span>
            </a>
          ))}
        </div>

        {/* CTA Link */}
        <div className="text-center mt-10">
          <Link
            to="/prensa"
            className="inline-flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-colors group"
          >
            Ver todas las menciones en prensa
            <svg
              className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
